import { Button, Icon, Tooltip } from "@chakra-ui/react";
import { ElementType } from "react";
import { shade } from "polished";

interface TableListModalButtonProps {
  icon: ElementType;
  bg: string;
  color: string;
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

export function TableListModalButton({
  bg,
  icon,
  color,
  onClick,
  disabled = false,
  label = "",
}: TableListModalButtonProps) {
  return (
    <Tooltip label={label} hasArrow>
      <Button
        bg={bg}
        color={color}
        onClick={onClick}
        _hover={{
          backgroundColor: shade(0.2, bg),
        }}
        _active={{
          backgroundColor: shade(0.2, bg),
        }}
        mr="4px"
        disabled={disabled}
      >
        <Icon as={icon} />
      </Button>
    </Tooltip>
  );
}
